import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared';
import { RoleSecurityDto } from './dto/role-security.dto';
import { BulkRoleSecurityUpsertDto } from './dto/bulk-role-security-upsert.dto';

@Injectable({
  providedIn: 'root',
})
export class SecurityService {
  constructor(private _apiService: ApiService) {}

  getRoleSecuritiesForUserRole(userRoleId: number): Promise<RoleSecurityDto[]> {
    return this._apiService.get(`Security/UserRole/${userRoleId}/RoleSecurities`);
  }

  upsertRoleSecurity(dto: RoleSecurityDto): Promise<number> {
    return this._apiService.post('Security/RoleSecurity/Upsert', dto);
  }

  bulkUpsertRoleSecurity(dto: BulkRoleSecurityUpsertDto): Promise<void> {
    return this._apiService.post('Security/RoleSecurity/BulkUpsert', dto);
  }
}
